// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.removed-trademarks_removed-trademarks_IZSRo {
    opacity: 0.75;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-removed-trademarks/removed-trademarks.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB","sourcesContent":[".removed-trademarks {\n    opacity: 0.75;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `removed-trademarks_removed-trademarks_IZSRo`;
export { _1 as "removed-trademarks" };
export var removedTrademarks = `removed-trademarks_removed-trademarks_IZSRo`;
export default ___CSS_LOADER_EXPORT___;
